












import { Vue, Component, Prop } from 'vue-property-decorator'
import { getToken } from '@/utils/cookies'

@Component({
  inheritAttrs: false,
})
export default class extends Vue {
  @Prop({ type: String, default: '' }) public customClass!: string
  @Prop({ type: String, default: '' }) public link!: string
  @Prop({ type: Boolean, default: false }) public disabled!: boolean

  public loading: boolean = false

  public async handleClick(e: Event) {
    e.preventDefault()
    e.stopPropagation()

    if (!this.link || this.loading) {
      if (!this.link) {
        console.error('No link provided.')
      }
      return
    }

    this.loading = true

    try {
      const token = getToken()
      if (!token) {
        console.error('Authorization token is missing.')
        this.loading = false
        return
      }

      const response = await fetch(this.link, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })

      if (!response.ok) {
        throw new Error(
          `Failed to fetch the resource. Status: ${response.status}`
        )
      }

      const contentType = response.headers.get('Content-Type') || ''
      const blob = await response.blob()
      const url = window.URL.createObjectURL(blob)

      if (contentType.startsWith('image/')) {
        // Render the image in the new tab
        window.open(url, '_blank')
      } else if (contentType.startsWith('video/')) {
        // Open the PDF directly in a new tab
        window.open(url, '_blank')
      } else {
        // Default: Download the file
        const anchor = document.createElement('a')
        anchor.href = url
        anchor.download = this.link.split('/').pop() || 'download'
        anchor.click()
        window.URL.revokeObjectURL(url)
      }
    } catch (error) {
      console.error('Error fetching the resource:', error)

      Vue.prototype.$notify({
        title: 'Open Link',
        message: 'Failed to open the link',
        type: 'error',
        duration: 3000,
      })
    } finally {
      this.loading = false
    }
  }
}
